module.exports = __webpack_public_path__ + "static/media/copy.61d58a8c.svg";